module.exports = __webpack_public_path__ + "img/nav-header-mobile-engagement.525b856.jpg";